export default "__VITE_ASSET__DG2d2I5B__"